import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { selectors as shipmentSelectors } from 'state/shipments';
import { actions as addressActions } from 'state/addresses';
import addressesSelectors from 'state/addresses/selectors';
import { selectors as uiSelectors } from 'state/ui';
import AddressSelector from './AddressSelector';
import { MODE } from './constants';

const enhance = compose(
  withTranslation('AddressSelector'),
  connect(
    (state, { shipmentKey, stopType }) => ({
      address: shipmentSelectors.getShipmentAddress(
        state,
        shipmentKey,
        stopType
      ),
      rawAddress: shipmentSelectors.getShipmentRawAddress(
        state,
        shipmentKey,
        stopType
      ),
      addresses: addressesSelectors.getLoadedAddresses(state),
      totalAddresses: addressesSelectors.getTotalLoadedAddresses(state),
      loading: uiSelectors.isLoadingAddresses(state, shipmentKey, stopType),
      shipmentKey,
      stopType,
    }),
    {
      changeAddress: addressActions.changeAddress,
      openAddressModal: addressActions.openAddressModal,
      loadMoreAddresses: addressActions.loadMoreAddresses,
    }
  ),
  withHandlers(({ closeModal }) => ({
    selectAddress:
      ({ changeAddress, shipmentKey, stopType }) =>
      ({ value }) => {
        changeAddress({ shipmentKey, stopType, address: value });
        closeModal();
      },
    createAddress:
      ({ openAddressModal, shipmentKey, stopType }) =>
      () => {
        openAddressModal({ shipmentKey, stopType });
        closeModal();
      },
    modifyAddress:
      ({ openAddressModal, shipmentKey, stopType }) =>
      () => {
        openAddressModal({ shipmentKey, stopType, isEditMode: true });
        closeModal();
      },
    quoteWithZipcode:
      ({ address, shipmentKey, stopType, changeAddress }) =>
      () => {
        changeAddress({ shipmentKey, stopType, address });
        closeModal();
      },
    loadMoreAddresses:
      ({ loadMoreAddresses, shipmentKey, stopType }) =>
      () => {
        loadMoreAddresses({ shipmentKey, stopType });
      },
    handleIsRowLoaded:
      ({ addresses, loading }) =>
      ({ index }) => {
        return index < addresses.length - 1 || loading;
      },
  })),
  withProps(({ address, addresses }) => ({
    mode: !!address?.id
      ? MODE.SELECTED
      : address?.isZipcode
      ? MODE.ZIPCODE
      : MODE.SEARCH,
    options: addresses,
  }))
);

export default enhance(AddressSelector);
